import { FormBase } from "core/components";

export default class FacilityOrderTemplateEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "importReferenceId",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.IMPORT_REFERENCE_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.IMPORT_REFERENCE_PLACEHOLDER",
                    rules: "required|string",
                },
                {
                    name: "inactiveReasonId",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.INACTIVE_REASON_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.INACTIVE_REASON_PLACEHOLDER",
                    rules: 'integer',
                },
                {
                    name: "insuranceInfo",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.INSURANCE_INFO_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.INSURANCE_INFO_PLACEHOLDER",
                    rules: ['string', 'max:50'],
                },
                {
                    name: "note",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.NOTE_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.NOTE_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "branchId",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.BRANCH_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.BRANCH_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "facilityOrderTemplateMissingDocuments",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.MISSING_DOCUMENTS_LABEL",
                },
                {
                    name: "woundLocation",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.WOUND_LOCATION_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.WOUND_LOCATION_PLACEHOLDER",
                    rules: ['string', 'max:50'],
                },
                {
                    name: "secondaryInsuranceVerified",
                    label: "",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.SECONDARY_INSURANCE_VERIFIED_PLACEHOLDER",
                    rules: ['string', 'max:50'],
                },
                {
                    name: "trackingCaseId",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.TRACKING_CASE_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.TRACKING_CASE_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "isReviewed",
                    type: "bool",
                },
                {
                    name: "dxCode1",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE1_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE1_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode2",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE2_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE2_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode3",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE3_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE3_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode4",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE4_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE4_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode5",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE5_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE5_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode6",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE6_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE6_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode7",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE7_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE7_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "dxCode8",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE8_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.DX_CODE8_PLACEHOLDER",
                    rules: 'string',
                },
                {
                    name: "missingProduct",
                    type: "bool",
                },
                {
                    name: "swo",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.SWO_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.SWO_PLACEHOLDER",
                    rules: ['string', 'max:50'],
                },
                {
                    name: "isPortalNoteActive",
                    type: "bool",
                },
                {
                    name: "portalNote",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.PORTAL_NOTE_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.PORTAL_NOTE_PLACEHOLDER",
                    rules: "string",
                },
            ],
        };
    }
}